import {
  TextField,
  Typography,
} from "@material-ui/core";
import {
  Autocomplete,
  GoogleMap,
  Marker,
  useJsApiLoader,
} from "@react-google-maps/api";
import RegularButton from "components/CustomButtons/Button";
import { validateObject } from "helpers/validateObject";
import { useToggle } from "hooks/useToggle";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import stationaryIcon from "../../assets/icons/68x68-alertatanque.png";
import cylinderIcon from "../../assets/icons/68x68-alertacilindros.png";
import { getMapByCoordinates } from "redux/actions/customers/customersAction";
import MyLocationIcon from "@material-ui/icons/MyLocation";
import StreetviewIcon from "@material-ui/icons/Streetview";
import { CoordsComponent } from "./CoordsComponent";
import { Search } from "@material-ui/icons";
import { useForm } from "hooks/useForm";
import { useSearch } from "hooks/useSearch";

const libraries = ["places"];

const initialValues = {
  coordLat: "",
  coordLng: "",
}

const fieldValidations = {
  coordLat: {required: true},
  coordLng: {required: true},
}
export const MapComponent = (props) => {
  const dispatch = useDispatch();
  const {
    getAddress,
    handleLocation = null,
    location,
    blockSearch = false,
    switchCss = false,
    type = null,
  } = props;

  const { account, mapInfo } = useSelector(
    ({ customersReducer }) => customersReducer
  );
  const { rules } = useSelector(({ login }) => login);
  const isActive = rules.includes("customer-pin".toUpperCase());
  const [autoComplete, setAutoComplete] = useState(null);
  const [mapPosition, setMapPosition] = useState({
    lat: location?.latitude || 0,
    lng: location?.longitude || 0,
  });
  const [isByCoords, setIsByCoords] = useToggle();
  const [newZoom, setNewZoom] = useState(8);
  const [pointer, setPointer] = useState({
    url: null,
  });
  const { inputValues, handleInputOnChange, fieldErrors } = useForm(initialValues, fieldValidations);
  const { coordLat, coordLng } = inputValues;
  const {setSnackbar} = useSearch()

  const { isLoaded, loadError } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: process.env.REACT_APP_MAPS_API_KEY || "",
    libraries,
  });
  const handleAutoCompleteIsLoad = (inputAutoComplete) => {
    setAutoComplete(inputAutoComplete);
  };

  const handleAutoCompletePlaceIsChanged = () => {
    if (autoComplete !== null) {
      setAutoComplete(autoComplete);
      const places = autoComplete.getPlace();
      getAddress(places.address_components);
      const lat = places?.geometry?.location.lat();
      const lon = places?.geometry?.location.lng();
      handleLocation && handleLocation({ latitude: lat, longitude: lon });
    }
  };

  const handleDragEnd = (value) => {
    const latLng = value.latLng;
    const lat = latLng.lat();
    const lng = latLng.lng();
    if(handleLocation){
      handleLocation({ latitude: lat, longitude: lng });
    }
    handleCoords(lat, lng)
    setMapPosition({ lat, lng });
  };

  const handleCoords = (lat, lng) => {
    if(lat.length === 0 || lng.length === 0) return setSnackbar('Coordenadas Requeridas')
    dispatch(getMapByCoordinates(lat, lng));
  };

  useEffect(() => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(function(position) {
        const lat = position.coords.latitude;
        const lon = position.coords.longitude;
        if (validateObject(account)) {
          const { address } = account;
          handleLocation &&
            handleLocation({
              latitude: address.latitude,
              longitude: address.longitude,
            });
        } else {
          handleLocation && handleLocation({ latitude: lat, longitude: lon });
        }
      });
    }
  }, []);

useEffect(() => {
  setNewZoom(18);
  let iconUrl = null;
  switch (type) {
    case "ESTACIONARIO":
      iconUrl = stationaryIcon;
      break;
    case "PORTATIL":
      iconUrl = cylinderIcon;
      break;
    default:
      iconUrl = null;
  }
  
  setPointer({
    url: iconUrl,
  });
}, [account, autoComplete, type]);

  useEffect(() => {
    setMapPosition({
      lat: location?.latitude || 0,
      lng: location?.longitude || 0,
    });
  }, [location]);

  useEffect(() => {
    if (!blockSearch && mapInfo?.address) {
      getAddress(mapInfo.address);
      setMapPosition({
        lat: mapInfo.location.lat,
        lng: mapInfo.location.lng,
      });
      handleLocation({
        latitude: mapInfo.location.lat,
        longitude: mapInfo.location.lng,
      });
    }
  }, [mapInfo]);

  if (loadError) {
    return (
      <Typography
        variant="subtitle2"
        style={{ textAlign: "center", padding: 16 }}
      >
        No se pudo cargar el mapa
      </Typography>
    );
  }

  if (!isLoaded) {
    return (
      <Typography
        variant="subtitle2"
        style={{ textAlign: "center", padding: 16 }}
      >
        Cargando mapa...
      </Typography>
    );
  }

  return (
    <>
      {blockSearch ? null : isByCoords ? (
        <CoordsComponent
          lat={coordLat}
          lng={coordLng}
          onChange={handleInputOnChange}
          errors={fieldErrors}
        />
      ) : (
        <Autocomplete
          onLoad={handleAutoCompleteIsLoad}
          restrictions={{
            country: ["mx"],
          }}
          onPlaceChanged={handleAutoCompletePlaceIsChanged}
          style={{ position: "absolute", left: 0, bottom: 0 }}
        >
          <>
            <TextField
              fullWidth
              label="Dirección Autocompletado"
              variant="outlined"
              placeholder=""
              style={{
                marginBottom: 8,
              }}
            />
          </>
        </Autocomplete>
      )}
      {!blockSearch && (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            gap: 4,
            transition: "all 0.3s ease",
            marginBottom: 8,
          }}
        >
          {isByCoords && (
            <RegularButton
              justIcon
              color="info"
              onClick={() => handleCoords(coordLat, coordLng)}
              tooltip="Buscar"
              style={{ margin: 0 }}
            >
              <Search />
            </RegularButton>
          )}
          <RegularButton
            justIcon
            color="success"
            onClick={setIsByCoords}
            tooltip={
              isByCoords
                ? "Ubicación por Dirección"
                : "Ubicación por coordenadas"
            }
            style={{ margin: 0 }}
          >
            {!isByCoords ? <MyLocationIcon /> : <StreetviewIcon />}
          </RegularButton>
        </div>
      )}
      <GoogleMap
        mapContainerClassName={
          switchCss ? "form_customer_map_" : "form_customer_map"
        }
        zoom={newZoom}
        center={mapPosition}
        options={{
          fullscreenControl: false,
        }}
      >
        <Marker
          draggable={isActive}
          onDragEnd={handleDragEnd}
          position={{
            lat: location?.latitude,
            lng: location?.longitude,
          }}
           icon={pointer.url}
        />
        {!location ? (
          <Typography
            variant="subtitle2"
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
          >
            Ubicación no disponible
          </Typography>
        ) : null}
      </GoogleMap>
    </>
  );
};
